import React, { FunctionComponent } from 'react';

export const Presentation: FunctionComponent = () => {
  return (
    <div className="footer-simple-wrapper">
      <div className="rtf-copyright">Copyright READY TO FASHION. Inc, All Rights Reserved.</div>
    </div>
  );
};
